import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFaqs } from '../../api/fetch-faqs';

export const fetchFaqsThunk = createAsyncThunk(
    'fetchFaqs',
    async () => fetchFaqs(),
);
